import { Module } from '../../ts/Module';

/**
 * Similar to ng-click, but checks for tb-disabled
 *
 * Usage:
 *
 *  a(tb-button-click="doAction()")
 *  a(tb-button-click="doAction()" tb-disabled="isDisabled()")
 *
 */
Module.instance().directive('tbButtonClick', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const clickFn = $parse(attr['tbButtonClick']);

        element.on('click', (event: JQuery.Event) => {
          if (!element.hasClass('tb-disabled')) {
            scope.$apply(() => {
              clickFn(scope, {$event : event});
            });
          }
        });
      }
    };
  }
]);
